/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState, useCallback } from "react";
// import staticGiftLogo from "../../Assets/NewList/powered-gift.png";
// import CrossBTN from "../../Assets/cross-earn.png";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { onGetPromotional } from "../../Store/Slices/promotionalSlice";
import { useDispatch, useSelector } from "react-redux";
import order from "../../Assets/order.png";
import profile from "../../Assets/profileNew.png";
import contact from "../../Assets/contact.png";
import { onGetofferMaster } from "../../Store/Slices/offerMasterSlice";
import getTranslationData from "../../TranslationUtility/TranslationUtility";
// import { onSessionLogoutSubmit } from "../../Store/Slices/sessionLogoutSlice";
import logout from "../../../src/Assets/logout_new.png";
import {
  ApplyThemeStyles,
  ClientInfo,
  getConfigValue,
  GetImageUrl,
  ThemeData,
  trackEvent,
} from "../../Components/Utility/Utility";
import { getProductList } from "../../Store/Slices/productSlice";
import { setProduct } from "../../Store/Slices/productDataSlice";
import { encryptURLParam } from "../../Common/Axios/encrypt";


const DesktopHeader = ({
  scroll,
  matchCategory,
  validateLoginTokenData,
  getInitials,
}) => {
  const themeData = ThemeData();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const translation = getTranslationData();
  const dropdownRef = useRef(null);
  const [firstPageLoaded, setFirstPageLoaded] = useState(false);
  const modal = useRef(null);
  const isLogin = sessionStorage.getItem("login");
  const [selectedProduct, setSelectedProduct] = useState(null);
  const promotionalList = useSelector((state) => state.promotionalReducer);
  const [promotinalData, setPromotionalData] = useState();
  const [isSearching, setIsSearching] = useState(false);
  const [visibleCount, setVisibleCount] = useState(
    Object.keys(matchCategory)?.length
  );
  const clientinfo = ClientInfo();
  const navRef = useRef(null);
  const [isMoreOpen, setIsMoreOpen] = useState(false);
  useEffect(() => {
    const updateVisibleCount = () => {
      if (!navRef.current) return;
      const containerWidth = navRef.current.offsetWidth;
      let totalWidth = 0;
      let count = 0;

      const testSpan = document.createElement("span");
      testSpan.style.visibility = "hidden";
      testSpan.style.position = "absolute";
      testSpan.style.whiteSpace = "nowrap";
      testSpan.className = "nav-link px-2";
      document.body.appendChild(testSpan);

      Object.keys(matchCategory).forEach((cat) => {
        testSpan.innerText = cat;
        totalWidth += testSpan.offsetWidth + 32; // padding + margin
        if (totalWidth < containerWidth - 100) {
          count++;
        }
      });

      document.body.removeChild(testSpan);
      setVisibleCount(count);
    };

    updateVisibleCount();

    const observer = new ResizeObserver(updateVisibleCount);
    if (navRef.current) observer.observe(navRef.current);

    return () => observer.disconnect();
  }, [matchCategory]);

  const firstName = validateLoginTokenData?.memberProfile?.firstName  ?? "";
  const lastName = validateLoginTokenData?.memberProfile?.lastName ?? "";
  // const firstName = validateLoginTokenData.firstName;
  // const lastName = validateLoginTokenData.lastName;
  const [placeholder] = useState(translation?.searchForGiftcard);
  const [isSearchActive, setIsSearchActive] = useState(false);
  const loginAuthData = useSelector((state) => state.loginAuthReducer);
  const [isModal, setIsModal] = useState(false);

  useEffect(() => {
    if (loginAuthData?.data?.length) {
      dispatch(onGetPromotional());
      dispatch(onGetofferMaster());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loginAuthData?.data?.length]);
  // const loginDetails = useSelector((state) => state.loginReducer);
  const handleLogout = (e) => {
    navigate("/logout");
  };
  const handleClick = (item) => {

    trackEvent("search_product", {
      search_term: item?.name,
      found_count: "",
      search_url: window.location.href,
    });
    dispatch(setProduct(item));
    // Conditionally encrypt the productId parameter based on environment setting
    const productId = item?.id.toString();
    const finalProductId = process.env.REACT_APP_IS_ENCRYPTION_ENABLED === 'false'
      ? productId
      : encryptURLParam(productId);
    navigate(`/giftcard?productId=${finalProductId}`, { state: { item } });
    setSearchTerm("");
    setFilteredResults([]);
    setIsSearching(false);
    setIsSearchActive(false);
  };

  // const productData = useSelector(
  //   (state) => state.productReducer.productById?.[0]?.products
  // );
  // const ClientProducts = useSelector(
  //   (state) =>
  //     state?.ClientProductMappingbyIdReducer.data?.[0]?.clientProductMapping
  // );
  useEffect(() => {
    if (Array.isArray(promotionalList?.GetPromotional)) {
      const today = new Date().setHours(0, 0, 0, 0);

      const filteredData = promotionalList?.GetPromotional?.filter((item) => {
        const endDate = new Date(item.endDate).setHours(0, 0, 0, 0);
        return item.enabled === true && endDate > today;
      });

      setPromotionalData(filteredData);
    }
  }, [promotionalList?.GetPromotional]);
  const [showPromotional, setShowPromotional] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchPageNumber, setSearchPageNumber] = useState(0);
  const [hasMoreSearchResults, setHasMoreSearchResults] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const searchLoaderRef = useRef(null);
  const [keepTyping, setKeepTyping] = useState(false);

  const handleChangeOptimized = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
    setIsSearchActive(true);

    if (value.trim() === "") {
      setFilteredResults([]);
      setSearchPageNumber(0);
      setHasMoreSearchResults(true);
      setFirstPageLoaded(false);
      setKeepTyping(false);
      setIsSearching(false);
      return;
    }

    if (value.trim().length < 3) {
      setFilteredResults([]);
      setSearchPageNumber(0);
      setHasMoreSearchResults(true);
      setFirstPageLoaded(false);
      setKeepTyping(true);     // show keep typing
      setIsSearching(false);   // hide "no record"
      return;
    }
    setKeepTyping(false);
    setIsSearching(false);
    setIsLoadingMore(true);

    // reset pagination
    setFilteredResults([]);
    setSearchPageNumber(0);
    setHasMoreSearchResults(true);
    setFirstPageLoaded(false);

    const payload = {
      search: value,
      pageNumber: 1,
      pageSize: 10,
    };

    dispatch(getProductList(payload))
      .then((response) => {
        const data = response?.payload?.response?.products || [];
        const totalCount = response?.payload?.response?.totalCount || 0;

        setFilteredResults(data);
        setHasMoreSearchResults(data.length < totalCount);
        setSearchPageNumber(1);        // last loaded page
        setFirstPageLoaded(true);

        // 3️⃣ ≥3 chars but no results
        if (data.length === 0) {
          setIsSearching(true);        // show "No record found"
        }
      })
      .finally(() => {
        setIsLoadingMore(false);
      });
  };



  // Load more search results
  const loadMoreSearchResults = useCallback(() => {
    if (
      isLoadingMore ||
      !hasMoreSearchResults ||
      !firstPageLoaded ||
      searchTerm.trim().length < 3
    ) {
      return;
    }

    setIsLoadingMore(true);
    const nextPage = searchPageNumber + 1;

    const payload = {
      search: searchTerm,
      pageNumber: nextPage,
      pageSize: 10,
    };

    dispatch(getProductList(payload))
      .then((response) => {
        const newData = response?.payload?.response?.products || [];
        const totalCount = response?.payload?.response?.totalCount || 0;

        setFilteredResults((prev) => {
          const updated = [...prev, ...newData];
          setHasMoreSearchResults(updated.length < totalCount);
          return updated;
        });

        setSearchPageNumber(nextPage);
      })
      .finally(() => {
        setIsLoadingMore(false);
      });
  }, [
    searchTerm,
    searchPageNumber,
    isLoadingMore,
    hasMoreSearchResults,
    firstPageLoaded,
    dispatch,
  ]);

  // IntersectionObserver for search dropdown infinite scroll
  useEffect(() => {
    if (
      !searchLoaderRef.current ||
      !isSearchActive ||
      !hasMoreSearchResults ||
      !firstPageLoaded
    ) {
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && !isLoadingMore) {
          loadMoreSearchResults();
        }
      },
      {
        root: null,
        rootMargin: "20px",
        threshold: 0,
      }
    );

    observer.observe(searchLoaderRef.current);

    return () => observer.disconnect();
  }, [
    filteredResults.length,
    isSearchActive,
    hasMoreSearchResults,
    firstPageLoaded,
    isLoadingMore,
    loadMoreSearchResults,
  ]);



  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setFilteredResults([]);
      setSearchTerm("");
      setIsSearchActive(false);
    }

    if (modal.current && !modal.current.contains(event.target)) {
      setIsModal(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("scroll", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleImageClick = (item) => {
    // Conditionally encrypt the categoryId parameter based on environment setting
    const finalCategoryId = process.env.REACT_APP_IS_ENCRYPTION_ENABLED === 'false'
      ? item
      : encryptURLParam(item);
    setIsMoreOpen(false);
    navigate(`/productlist?categoryId=${finalCategoryId}`, {
      state: { item },
    });
  };

  useEffect(() => {
    if (searchTerm) {
      document.body.classList.add("no-scroll");
      setHasMoreSearchResults(true);

    } else {
      document.body.classList.remove("no-scroll");
    }
    if (searchTerm.trim().length < 3) return;
    setFilteredResults([]);
    setSearchPageNumber(0);
    setHasMoreSearchResults(true);
    setFirstPageLoaded(false)

    // manually load first page
    loadMoreSearchResults();
  }, [searchTerm]);

  const currentBalance = useSelector((state) => state.cardDataSliceReducer?.pointBalance);

  const V3Data = useSelector((state) => state.cardDataSliceReducer);

  useEffect(() => {
    if (location.pathname.endsWith("/otp")) {
      setShowPromotional(false);
    }
  }, [location.pathname]);

  const handleLogin = () => {
    const pathName = window.location.pathname;
    const search = window.location.search;
    localStorage.setItem("ProductListPage", pathName + search);
    localStorage.setItem("ProductListPage_back", pathName + search);
  };
  const memberData = useSelector(
    (state) =>
      state.getMemberSliceReducer?.MemberData?.memberBalance?.[0]?.pointBalance
  );
  const clientConfigurations = clientinfo?.clientData?.clientConfigurations;
  const isLoginDisabled = getConfigValue(clientConfigurations, "isLogin");
  const isEarn = clientConfigurations?.find((item) => item.configKey?.toLowerCase() === "isearn")?.configValue;
  const isBurn = clientConfigurations?.find((item) => item.configKey?.toLowerCase() === "isburn")?.configValue;

  useEffect(() => {
    ApplyThemeStyles(themeData);
  }, [themeData]);
  return (
    <>
      {isSearchActive && <div className="screen-blur" />}
      <header className="header forTab-hide mobile-hide">
        <div className={`fixheader top-hh ${scroll && "sticky"}`}>
          {showPromotional &&
            Array?.isArray(promotinalData) &&
            promotinalData?.map((item) => (
              <div className="top-hh">
                <div className="top-menu oaoa1">
                  <div className="d-flex ml-10 ">
                    <p className="promo">&nbsp;{item?.titleText}</p>
                    {(item?.link && item?.linkText) && (
                      <p className="mar-earn">
                        <Link to={item?.link} className="exp hoverPromo">
                          <span
                            dangerouslySetInnerHTML={{ __html: item?.linkText }}
                          />{" "}
                          <i className="fa-solid fa-arrow-right"></i>
                        </Link>
                      </p>
                    )}
                  </div>
                  <button
                    className="close-Btn "
                    onClick={() => setShowPromotional(false)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21"
                      height="21"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="var(--explore-earn-text-color)"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <line x1="18" y1="6" x2="6" y2="18" />
                      <line x1="6" y1="6" x2="18" y2="18" />
                    </svg>
                  </button>
                </div>
              </div>
            ))}
          <div className="main-header fitted ">
            <div className="container">
              <div className="row align-items-lg-center">
                <div className="col-xl-3 col-lg-4 col-7 order-0 order-lg-0"></div>
                <div className="col-xl-3 col-lg-2 col-5 order-1 order-lg-2"></div>
                <div className="col-xl-6 col-lg-6 col-12 order-2 order-lg-1"></div>
              </div>
            </div>
          </div>
          <div className="botheader">
            <div className="container">
              <div className="d-flex  top-menu">
                <div className=" d-xl-none d-none p-3">
                  <div className="mobilemenulogo text-center">
                    <Link to="/">{/* <img src={Logo} alt="img" /> */}</Link>
                  </div>
                  <div className="menuclosebtn">
                    <Link to="#">
                      <i className="las la-times"></i>
                    </Link>
                  </div>
                </div>
                <div className="">
                  <div className="button"></div>
                  <div className="logo">
                    <Link
                      to="/"
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        gap: "7px",
                      }}
                    >
                      <img
                        src={GetImageUrl(clientinfo.logoUrl)}
                        alt="img"
                        style={{ width: "104.48px", height: "31.87px" }}
                      />
                      {clientinfo?.giftLogo && (
                        <>
                          <div className="vertical-line"></div>
                          <img
                            src={GetImageUrl(clientinfo?.giftLogo)}
                            alt="img"
                            style={{ width: "54.18px", height: "31.09px" }}
                          />
                        </>
                      )}
                    </Link>
                  </div>
                </div>
                <div
                  className={`thecate ${matchCategory?.length > 3 ? "ms-5" : "ml-20"
                    } ${isLogin ? "wid50" : "wid55"}`}
                  ref={navRef}
                >
                  <nav id="cssmenu" className="">
                    <ul>
                      {Object.keys(matchCategory)

                        .slice(0, visibleCount)
                        .map((item1, index) => (
                          <li key={index}>
                            <Link
                              to={`/productlist?categoryId=${process.env.REACT_APP_IS_ENCRYPTION_ENABLED === 'false'
                                ? item1
                                : encryptURLParam(item1)
                                }`}
                              state={{ item1 }}
                            >
                              {item1}
                            </Link>
                          </li>
                        ))}
                      {visibleCount < Object.keys(matchCategory)?.length && (
                        <li className="more-button"
                          onMouseEnter={() => setIsMoreOpen(true)}
                          onMouseLeave={() => setIsMoreOpen(false)}
                        >
                          <span className="linkprop">
                            {translation?.more}{" "}
                            <i className="fas fa-angle-down" style={{ marginLeft: '4px' }}></i>
                          </span>
                          {isMoreOpen &&
                            <ul className="submenulist">
                              {Object.keys(matchCategory)
                                .slice(visibleCount)
                                .map((item1, index) => (
                                  <li
                                    key={index + visibleCount}
                                    className={`menu-item ${selectedProduct === item1 ? "hovered" : ""
                                      }`}
                                    onMouseEnter={() => setSelectedProduct(item1)}
                                    onMouseLeave={() => setSelectedProduct(null)}
                                  >
                                    <div
                                      className="a"
                                      onClick={() => handleImageClick(item1)}
                                    >
                                      {item1}
                                    </div>
                                  </li>
                                ))}
                            </ul>
                          }
                        </li>
                      )}
                    </ul>
                  </nav>
                </div>
                <div className="login-btn1">
                  <div className="thesearch " ref={dropdownRef}>
                    <div className="searchboxmaindiv">
                      <div className="searchbox">
                        <a id="btnsearch">
                          <i className="las la-search"></i>
                        </a>
                        <input
                          name="ctl00$txtsearch"
                          type="text"
                          id="txtsearch"
                          className="autosuggest"
                          autoComplete="off"
                          placeholder={placeholder}
                          value={searchTerm}
                          onChange={handleChangeOptimized}
                        />
                      </div>
                      {searchTerm && (
                        <ul
                          className="dropdown1"
                        >

                          {filteredResults?.length > 0
                            ? filteredResults.map((item, index) => (
                              <li
                                onClick={() => handleClick(item)}
                                key={`${item.id}-${index}`}
                                className="dropdown-item d-flex align-item-center"
                              >
                                <i
                                  className="las la-search mx-2"
                                  style={{ fontSize: "1.5em" }}
                                ></i>{" "}
                                {item.name}
                              </li>
                            ))
                            : keepTyping ? (
                              <li className="dropdown-item text-center py-2">
                                {translation?.keepTyping}
                              </li>
                            ) : isSearching && (
                              <li className="dropdown-item text-center py-2">
                                {translation?.NoRecordsFound}
                              </li>
                            )
                          }

                          {/* Loader element for infinite scroll */}
                          {hasMoreSearchResults &&
                            // filteredResults.length > 0 && 
                            <li
                              ref={searchLoaderRef}
                              className="dropdown-item text-center py-0"
                              style={{ minHeight: "10px" }}
                            >
                              {/* {isLoadingMore ? "Loading more..." : ""} */}
                              {isLoadingMore ? (
                                <span>Loading more...</span>
                              ) :
                                isSearching ? (
                                  <span style={{ opacity: 0 }}>
                                    Load trigger
                                  </span>
                                )
                                  : null}
                            </li>

                            // )
                          }
                        </ul>
                      )}
                    </div>
                  </div>
                  {isLogin && isEarn !== 2 && isBurn !== 2 ? (
                    <div className="point-div ">
                      <div id="ctl00_pointdesk" className="prodiscounter44">
                        <i className="fa-solid fa-star buy mar"></i>{" "}
                        {currentBalance?.toLocaleString()}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="desktop-headphone-icon">
                    <ul>
                      <li className="headphone-icon">
                        <a href="/contact-us">
                          <i class="las la-headphones home-tab"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="theprofile">
                    <div className={`top-right clearfix`}>
                      {isLogin ? (
                        <ul className="">
                          <li className="meiconbtn">
                            <span
                              onClick={() => setIsModal(true)}
                              className="profile-p"
                            >
                              <div className="profile ">
                                <div className="profile-initials">
                                  {getInitials(firstName, lastName)}
                                </div>
                              </div>
                            </span>
                            {isModal ? (
                              <div
                                className="logindropbox logindrop-ch"
                                ref={modal}
                              >
                                <div className="logindrop2">
                                  <ul className="pb-1">
                                    <li className="profile_li">
                                      <img
                                        className="icon-sz"
                                        src={profile}
                                        alt="profie"
                                      />
                                      <Link
                                        onClick={() => setIsModal(false)}
                                        to="/myprofile"
                                        className="link-border"
                                      >
                                        {translation?.myProfile}
                                      </Link>
                                    </li>
                                    <li className="profile_li">
                                      <img
                                        className="icon-sz"
                                        src={order}
                                        alt="order"
                                      />
                                      <Link
                                        to="/orders"
                                        onClick={() => setIsModal(false)}
                                        className="link-border"
                                      >
                                        {translation?.orders}
                                      </Link>
                                    </li>
                                    <li className="profile_li">
                                      <img
                                        className="icon-sz"
                                        src={contact}
                                        alt="contact"
                                      />
                                      <Link
                                        onClick={() => setIsModal(false)}
                                        to="/contact-us"
                                      >
                                        {translation?.contactUs}
                                      </Link>
                                    </li>
                                    <li className="profile_li">
                                      <img
                                        className="icon-sz"
                                        src={logout}
                                        alt="contact"
                                      />
                                      {/* <Logout width={18} color={"#919191"} height={18} className="icon-sz" /> */}
                                      <span
                                        onClick={handleLogout}
                                        className="logout-span"
                                      >
                                        Logout
                                      </span>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </li>
                        </ul>
                      ) : (isLoginDisabled?.isLoginDisabled !== 1 &&
                        <ul className="head-login">
                          <li id="ctl00_lnklogin">
                            <Link
                              to={V3Data?.SignInUrl}
                              onClick={() => handleLogin()}
                              className="login_btn"
                            >
                              {translation?.loginLabel}
                            </Link>
                          </li>
                        </ul>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default DesktopHeader;
